import api from '@/api/api_geodp'

export default class CityParametersService {
  retrieveParameters () {
    // Mock data.
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       logo: 'http://www.angers.fr/fileadmin/templates/ville/pages/img/logo-ville-angers.svg',
    //       // cityName: 'Mairie de Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson',
    //       cityName: "Mairie d'Angers"
    //     })
    //   }, 50)
    // })

    return api.get('parameters')
      .then((response) => {
        return new Promise((resolve) => { resolve(response.data) })
      })
      .catch((error) => {
        return new Promise((resolve, reject) => { reject(error) })
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/cityParametersService.js